"use client";
import Image from "next/image";
import "./About.scss";
import AnimateHeight from "react-animate-height";
import { useState, useRef, useEffect } from "react";

export default function AboutPackage({ img, info, name }) {
  const [height, setHeight] = useState(155);
  const [showReadMore, setShowReadMore] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    const checkHeight = () => {
      if (contentRef.current) {
        const contentHeight = contentRef.current.scrollHeight;
        setShowReadMore(contentHeight > 155);
      }
    };

    // Initial check
    checkHeight();

    // Add resize listener
    window.addEventListener("resize", checkHeight);

    return () => window.removeEventListener("resize", checkHeight);
  }, [info]);

  const toggleHeight = () => {
    setHeight(height === 155 ? "auto" : 155);
  };

  return (
    <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-2 sm:py-3 lg:py-4">
      <div className="flex flex-col md:flex-row items-center md:items-start gap-3 sm:gap-4">
        {/* Image Container */}
        <div className="w-full md:w-1/3 flex justify-center">
          <div className="relative w-full max-w-[320px] aspect-square rounded-2xl overflow-hidden shadow-lg">
            <Image
              loading="lazy"
              alt={`${name} image`}
              src={img}
              fill
              className="object-contain p-5"
              sizes="(max-width: 768px) 280px, 320px"
            />
          </div>
        </div>

        {/* Content Container */}
        <div className="w-full md:w-2/3">
          <div className="mb-2 sm:mb-3">
            <h2 className="text-3xl font-bold text-gray-900 mb-2 mt-0">
              {name}
            </h2>
            <div className="h-1 w-20 bg-blue-600 rounded"></div>
          </div>

          <div className="prose max-w-none">
            <AnimateHeight
              id="about-content"
              duration={500}
              height={height}
              className="overflow-hidden"
            >
              <div
                ref={contentRef}
                className="text-gray-700 leading-relaxed"
                dangerouslySetInnerHTML={{ __html: info }}
              />
            </AnimateHeight>
          </div>

          {showReadMore && (
            <button
              className="mt-1 text-blue-600 font-semibold hover:text-blue-800 transition-colors flex items-center gap-2"
              onClick={toggleHeight}
            >
              {height === 155 ? "Read More" : "Show Less"}
              <svg
                className={`w-4 h-4 transform transition-transform ${
                  height === 155 ? "" : "rotate-180"
                }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
